import React from "react";
import styled from "styled-components";
import { H4, Body } from "storybook-components/Typography";
import { Card } from "storybook-components/Card";

const SmallContainer = styled.a`
  display: flex;
  flex-wrap: wrap;
  height: 100%;
  text-decoration: none;
  color: inherit;
`;

const TextWrapper = styled.div`
  width: 100%;
  color: inherit;
  margin: auto;
  display: flex;
  flex-direction: column;
`;

const StyledCard = styled(Card)`
  min-height: 200px;
  border-radius: 10px;
  box-shadow: none;
  transition: color 0.1s ease-out, background-color 0.1s ease-out;
  color: ${({ theme }) => theme.colors.green5};
  &:hover {
    color: ${({ theme }) => theme.colors.green1};
    background-color: ${({ theme }) => theme.colors.green4};
    box-shadow: none;
  }
`;

const StyledCardTitle = styled(H4)`
  max-width: 320px;
  margin: 0;
  color: inherit;
  &:hover {
    color: inherit;
  }
`;

const StyledBody = styled(Body)`
  color: inherit;
  font-size: 1.11rem;
  max-width: 320px;
  margin-top: 10px;
`;

const LargeHubLinkCard = ({ title, subTitle, buttonHref }) => {
  return (
    <StyledCard>
      <SmallContainer href={buttonHref}>
        <TextWrapper>
          <StyledCardTitle>{title}</StyledCardTitle>
          <StyledBody>{subTitle}</StyledBody>
        </TextWrapper>
      </SmallContainer>
    </StyledCard>
  );
};

export default LargeHubLinkCard;
